<template>
  <v-main id="main-content">
    <the-filter-drawer></the-filter-drawer>
    <v-container fluid class="pa-0 main-content">
      <the-content-toolbar />
      <info-drawer />
      <Split
        :gutterSize="gutterSize"
        @onDragEnd="onDragEnd"
        direction="vertical"
        v-bind:class="{
          onlyTable: (tableVisible || mapVisible) && !splitViewEnabled,
        }"
      >
        <SplitArea :size="mapSize" :minSize="300">
          <the-map :size="mapSize"></the-map>
        </SplitArea>
        <SplitArea v-show="tableVisible" :size="tableSize" :minSize="300">
          <data-table-panel
            :map-visible="mapVisible"
            :table-visible="tableVisible"
            :horizontal-split-view="horizontalSplitView"
          />
        </SplitArea>
      </Split>
    </v-container>
  </v-main>
</template>

<script>
import { TheMap, TheFilterDrawer } from "@/components";
import { mapActions } from "vuex";
import InfoDrawer from "../components/Layout/InfoDrawer.vue";
import DataTablePanel from "../components/Table/DataTablePanel.vue";
import { setDefaultOptions } from "esri-loader";
import TheContentToolbar from "../components/Layout/TheContentToolbar.vue";
export default {
  name: "Home",
  components: {
    TheMap,
    TheFilterDrawer,
    InfoDrawer,
    TheContentToolbar,
    DataTablePanel,
  },
  data() {
    return {
      finished: false,
      parameterExpressions: {},
      tableSize: 0,
      mapSize: 100,
      tableVisible: false,
      mapVisible: true,
      splitViewEnabled: false,
      horizontalSplitView: false,
      nveTimeSeriesCount: 0,
      otherTimeSeriesCount: 0,
    };
  },
  computed: {
    gutterSize: function() {
      return this.mapVisible && this.tableVisible ? 8 : 0;
    },
  },
  methods: {
    ...mapActions(["setSplitSize"]),
    onDragEnd(size) {
      this.setSplitSize(size);
    },
    showMapOnly() {
      this.tableSize = 0;
      this.mapSize = 100;
      this.tableVisible = false;
      this.mapVisible = true;
      this.splitViewEnabled = false;
    },
    showTableOnly() {
      this.mapSize = 0;
      this.tableSize = 100;
      this.tableVisible = true;
      this.mapVisible = false;
      this.splitViewEnabled = false;
    },
    showSplitView() {
      this.mapSize = 50;
      this.tableSize = 50;
      this.tableVisible = true;
      this.mapVisible = true;
      this.splitViewEnabled = true;
      this.horizontalSplitView = false;
    },
    showSplitViewHorizontal() {
      this.mapSize = 50;
      this.tableSize = 50;
      this.tableVisible = true;
      this.mapVisible = true;
      this.splitViewEnabled = true;
      this.horizontalSplitView = true;
    },
  },
  created() {
    setDefaultOptions({
      version: "4.20",
      css: true,
      dojoConfig: {
        locale: "nb",
      },
    });

    this.$eventHub.$on("show-map-only", this.showMapOnly);
    this.$eventHub.$on("show-table-only", this.showTableOnly);
    this.$eventHub.$on("show-split-view", this.showSplitView);
    this.$eventHub.$on(
      "show-split-view-horizontal",
      this.showSplitViewHorizontal
    );
  },
};
</script>
<style>
div.onlyTable div.gutter.gutter-horizontal {
  display: none;
}

.box-content {
  height: calc(100% - 0px);
  width: 100%;
}

#wrap {
  height: 100%;
}

.box-content {
  background-color: #f7f5f5;
  overflow-x: hidden;
  padding-top: 5px;
  background-repeat: no-repeat;
  min-height: 200px;
}

.view-toggler {
  margin-left: 20px;
}

.view-icon {
  font-size: 18px;
  margin-right: 10px;
  cursor: pointer;
}

.sidebar-height {
  height: calc(100% - 88px);
  margin-top: 70px;
}

.btn {
  background-color: #bbbbbb;
  border-color: transparent;
  color: #ffffff;
}

.btn.btn-secondary.active.view-icon {
  color: white;
}

.box-header {
  position: relative;
  background-color: green;
  padding: 11px 8px 5px;
  color: white;
  height: 40px;
}

#wrap > .container {
  padding: 5px 0px 5px 0px;
  width: 650px;
  height: 100%;
  margin-bottom: 5px;
  border: solid 4px black;
}

#wrap {
  /* Negative indent footer by its height */
  margin: 0 auto -36px;
  /* Pad bottom by footer height */
  padding: 0 0 0px 0px;
}

#footer {
  height: 60px;
  text-align: center;
  background-color: purple;
  color: white;
  clear: both;
}

.container-fluid {
  height: 100%;
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow-y: hidden;
}

.split.split-horizontal,
.gutter.gutter-horizontal {
  height: 100%;
}

.split.split-vertical {
  /* height: calc(100% - 8px) !important; */
}

.bottom-bar {
  border-style: solid;
  border-top: 1px solid #d3d3d3;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 0px;
}

.main-content {
  height: calc(100% - 48px);
}
</style>
